import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { CurrentPlanDetails } from '../../types/plan';
import { CompliancePackageData } from '../../types/compliance';
import { EssentialPlan } from './EssentialPlan';
import { AdvancedPlan } from './AdvancedPlan';

export const PlanComparison = (props: {
    currentPlan: CurrentPlanDetails;
    compliancePackageData: CompliancePackageData;
    isUsSeller?: boolean;
}) => (
    <Stack gap="6" height="fit-content" direction={{ default: 'column', md: 'row' }}>
        <EssentialPlan
            badge="current"
            endDate={props.currentPlan.extendedEndDate || props.currentPlan.endDate}
            {...props}
        />
        <AdvancedPlan
            badge="recommended"
            containerProps={{ style: { borderWidth: '2px' }, borderColor: 'grey_1200' }}
            {...props}
        />
    </Stack>
);
